import { createImmerReducer } from '@reducers/utils/createReducer';
import * as c from './types';

const initialState: c.ModalState = {
  annotateStopErrorModal: {
    isOpen: false,
    data: null
  }
};

export default createImmerReducer(initialState, {
  [c.SHOW_ANNOTATE_STOP_ERROR_MODAL]: (state, { payload }) => {
    state.annotateStopErrorModal.isOpen = true;
    state.annotateStopErrorModal.data = payload;
  },
  [c.HIDE_ANNOTATE_STOP_ERROR_MODAL]: (state) => {
    state.annotateStopErrorModal.isOpen = false;
    state.annotateStopErrorModal.data = null;
  }
});
